package com.ustadmobile.core.util

fun min(x: Long, y: Long) = if(x < y) x else y
